import { useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";

type Options = {
	alwaysUseDefaultRoute?: boolean;
	replaceOnBack?: boolean;
};

export const useNavigateBackOrDefault = (
	defaultRoute?: string,
	{ alwaysUseDefaultRoute = false, replaceOnBack = false }: Options = {},
): (() => void) => {
	const navigate = useNavigate();
	const location = useLocation();

	return useCallback(() => {
		if (!defaultRoute) return;

		if (!alwaysUseDefaultRoute && location.key !== "default") {
			navigate(-1);
			return;
		}

		navigate(defaultRoute, { replace: replaceOnBack });
	}, [
		navigate,
		location.key,
		defaultRoute,
		alwaysUseDefaultRoute,
		replaceOnBack,
	]);
};
